// extracted by mini-css-extract-plugin
export default {"files-pagination":"files-pagination--_If0V"};